import { httpClient } from '@/Common/api/http_client';

/**
 *
 * @export getAllShippers
 * @returns { Promise<AxiosResponse<T>> }
 */
export function getAllShippers() {
  return httpClient.get('/merchant/shipper');
}

/**
 *
 * @export deleteShipper
 * @param {*} shipperId
 * @returns { Promise<AxiosResponse<T>> }
 */
export function deleteShipper(shipperId) {
  return httpClient.delete(`/merchant/shipper/${shipperId}`);
}

/**
 *
 * @export updateShipper
 * @param {*} shipperId
 * @param {*} shipper
 * @returns { Promise<AxiosResponse<T>> }
 */
export function updateShipper(shipperId, shipper) {
  return httpClient.put(`/merchant/shipper/${shipperId}`, shipper);
}

/**
 *
 * @export createShipper
 * @param {*} shipper
 * @returns { Promise<AxiosResponse<T>> }
 */
export function newShipper(shipper) {
  return httpClient.post('/merchant/shipper', shipper);
}
